<template>
    <component
        :is="tag"
        class="inline-flex items-center px-2.5 py-0.5 rounded"
        :class="[backgroundClassName, textClassName]"
        v-on="$listeners"
    >
        <slot />
    </component>
</template>

<script>
    export default {
        props: {
            tag: {
                type: String,
                default: 'span',
            },
            color: {
                type: String,
                default: 'gray',
                validator: (value) => ['blue', 'green', 'yellow', 'red', 'gray'].includes(value),
            },
        },

        computed: {
            backgroundClassName() {
                switch (this.color) {
                    case 'blue':
                        return 'bg-blue-100';
                    case 'red':
                        return 'bg-red-200';
                    case 'yellow':
                        return 'bg-yellow-200';
                    case 'green':
                        return 'bg-green-200';
                    case 'gray':
                    default:
                        return 'bg-gray-200';
                }
            },
            textClassName() {
                switch (this.color) {
                    case 'blue':
                        return 'text-blue-800';
                    case 'red':
                        return 'text-red-800';
                    case 'yellow':
                        return 'text-yellow-800';
                    case 'green':
                        return 'text-green-800';
                    case 'gray':
                    default:
                        return 'text-gray-800';
                }
            },

        },
    };
</script>
